const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';

export async function authenticateAdmin(identity: string): Promise<{ jwt: string }> {
  const res = await fetch(`${WORKER_URL}/api/admin/authenticate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ identity }),
  });
  if (!res.ok) throw new Error('Not authorized');
  return res.json();
}

export function getStoredJwt(): string | null {
  const jwt = localStorage.getItem('admin_jwt');
  if (!jwt) return null;
  // Check expiration — discard if expired or expiring within 60s
  try {
    const payload = JSON.parse(atob(jwt.split('.')[1]));
    if (payload.exp && payload.exp < Math.floor(Date.now() / 1000) + 60) {
      localStorage.removeItem('admin_jwt');
      return null;
    }
  } catch {
    localStorage.removeItem('admin_jwt');
    return null;
  }
  return jwt;
}

export function storeJwt(jwt: string) {
  localStorage.setItem('admin_jwt', jwt);
}

export function clearJwt() {
  localStorage.removeItem('admin_jwt');
}
